module.exports = __webpack_public_path__ + "img/pronaht-logo-simple.220693a2.svg";